import { FC } from 'react';
import { useParams } from 'react-router';
import { NavLink } from '@/routes-utils/navigation.tsx';
import { paths } from '@/routes-utils/paths.ts';
import * as auditoryInfoStyles from './auditory.css.ts';

const AuditoryItemLink: FC<{
  label: string;
  count: number;
  to: string;
}> = ({ count, label, to }) => (
  <NavLink to={to}>
    <div className={auditoryInfoStyles.auditoryItem}>
      <span>
        <span
          className={auditoryInfoStyles.auditoryNumber}
          data-testid={`${label}-count`}
        >
          {count}
        </span>
        &nbsp;
        <span>{label}</span>
      </span>
    </div>
  </NavLink>
);

export const Auditory: FC<{
  followingCount: number | undefined;
  followersCount: number | undefined;
}> = ({ followingCount, followersCount }) => {
  const username = useParams().username as string;

  return (
    <div className={auditoryInfoStyles.auditoryContainer}>
      <AuditoryItemLink
        to={paths.makeFollowing(username)}
        label={'following'}
        count={followingCount as number}
      />
      <AuditoryItemLink
        to={paths.makeFollowers(username)}
        label={'followers'}
        count={followersCount as number}
      />
    </div>
  );
};
